export default __webpack_public_path__ + "static/media/HamburgerMenuWhite.679c1ea9.svg";